import { Account as AccountV2 } from "features/Account/v2";
import { Profile as ProfileV2 } from "features/Account/v2/Profile";
import { Security as SecurityV2 } from "features/Account/v2/Security";
import { PlanAndBilling as PlanAndBillingV2 } from "features/Account/v2/PlanAndBilling";
import { Partnerships } from "features/Account/v2/Partnerships";
// import { Invite } from "features/Account/v2/Invite";

import {
  GeneralIcon,
  SecurityIcon,
  RecieptIcon,
  PlansIcon,
  RecieptMobileIcon,
} from "assets/icons";

export const MAIN_ACCOUNT_PATH = "/account";
export const ACCOUNT_OVERVIEW_PATH = "/account/profile";
export const ACCOUNT_SECURITY_PATH = "/account/security";
export const ACCOUNT_NOTIFICATION_PATH = "/account/notification";
export const ACCOUNT_TWO_FACTOR_AUTHENTICATION_PATH =
  "/account/two-factor-authentication";
export const ACCOUNT_PLAN_BILLING_PATH = "/account/plan-billing";
export const ACCOUNT_AVAILABLE_PLANS_PATH = "/account/available-plans";
export const ACCOUNT_PLAN_DETAIL_PATH = "/account/plan/:id/detail";
export const ACCOUNT_PAYMENT_PATH = "/account/payment-method";

// V2 Routes
export const MAIN_ACCOUNT_V2_PATH = "/settings";
export const ACCOUNT_OVERVIEW_V2_PATH = "/settings";
export const ACCOUNT_PLAN_BILLING_V2_PATH = "/settings/billing";
export const ACCOUNT_SECURITY_V2_PATH = "/settings/security";
// export const ACCOUNT_INVITE_V2_PATH = "/account/invite";
export const ACCOUNT_PARTNERSHIPS_V2_PATH = "/settings/partnerships";

export const accountRoutesV2 = [
  {
    path: MAIN_ACCOUNT_V2_PATH,
    component: <AccountV2 />,
    subRoute: [
      {
        path: "billing",
        component: <PlanAndBillingV2 />,
      },
      {
        path: ACCOUNT_OVERVIEW_V2_PATH,
        component: <ProfileV2 />,
      },
      {
        path: ACCOUNT_SECURITY_V2_PATH,
        component: <SecurityV2 />,
      },

      {
        path: ACCOUNT_PARTNERSHIPS_V2_PATH,
        component: <Partnerships />,
      },
    ],
  },
];

export const PROFILE_MENU = [
  {
    title: "My Profile",
    path: ACCOUNT_OVERVIEW_PATH,
    Icon: GeneralIcon,
    isVisible: true,
  },
  {
    title: "Plan & Billing",
    path: ACCOUNT_PLAN_BILLING_PATH,
    Icon: RecieptIcon,
    MobileIcon: RecieptMobileIcon,
    isVisible: true,
  },
  {
    title: "Available Plans",
    path: ACCOUNT_AVAILABLE_PLANS_PATH,
    Icon: PlansIcon,
    isVisible: false,
  },
  // {
  //   title: "Payment Methods",
  //   path: ACCOUNT_PAYMENT_PATH,
  //   Icon: PaymentMethodsIcon,
  //   isVisible: plan?.plan === "Premium",
  // },
  // {
  //   title: "Notifications",
  //   path: ACCOUNT_NOTIFICATION_PATH,
  //   Icon: NotificationIcon,
  //   isVisible: true,
  // },
  {
    title: "Security",
    path: ACCOUNT_SECURITY_PATH,
    Icon: SecurityIcon,
    isVisible: true,
  },
];
